import { render, staticRenderFns } from "./CardControls.vue?vue&type=template&id=deb80016&lang=html&"
import script from "./CardControls.vue?vue&type=script&lang=js&"
export * from "./CardControls.vue?vue&type=script&lang=js&"
import style0 from "./CardControls.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports